import { render, staticRenderFns } from "./UserNotifs.vue?vue&type=template&id=6baa66b6"
import script from "./UserNotifs.vue?vue&type=script&lang=js"
export * from "./UserNotifs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports